var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticClass:"send-patient-invite-modal",attrs:{"name":"send-patient-invite-modal","classes":['modal-window'],"transition":"scale","scrollable":"","adaptive":"","width":"800px","height":"auto"}},[_c('div',{staticClass:"modal-container"},[_c('send-patient-invite-tabs')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }